import React from 'react';

import { Row, Col, Form, Select, Input } from 'antd';
import { useTranslation } from 'react-i18next';

import bodyType from '../../../helpers/consts/bodyType';
import fuelType from '../../../helpers/consts/fuelType';
import colorType from '../../../helpers/consts/colorType';

const { TextArea } = Input;

const VehicleAdditionalDetails = ({ form }) => {
  const { t } = useTranslation();
  const translatedBodyType = bodyType.map((item) => ({
    value: item.value,
    label: t(`vehicles.bodyTypeOptions.${item.value}`) || item.label, // Default to original if translation fails
  }));

  const translatedColorType = colorType.map((item) => ({
    value: item.value,
    label: t(`vehicles.colorTypeOptions.${item.value}`) || item.label, // Default to original if translation fails
  }));

  const translatedFuelType = fuelType.map(item => ({
    value: item.value,
    label: t(`vehicles.fuelTypeOptions.${item.value}`) || item.label, // Default to original if translation fails
  }));

  return (
    <>
      <>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
              name="color"
              label={t('form.vehicleForm.vehicleAdditionalDetails.color')}
              rules={[
                {
                  required: true,
                  message: t(
                    'form.validationMessages.requiredField',
                    {
                      field: t(
                        'form.vehicleForm.vehicleAdditionalDetails.color'
                      ),
                    }
                  ),
                },
              ]}
            >
              <Select options={translatedColorType} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            {
              <Form.Item
                name="engineSize"
                label={t(
                  'form.vehicleForm.vehicleAdditionalDetails.engineSize'
                )}
              >
                <Input suffix={'cm3'} allowClear />
              </Form.Item>
            }
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="gearbox"
              label={t('form.vehicleForm.vehicleAdditionalDetails.gearbox')}
            >
              <Select allowClear>
                <Select.Option value="manual">
                  {t('vehicles.gearboxOptions.manual')}
                </Select.Option>
                <Select.Option value="automatic">
                  {t('vehicles.gearboxOptions.automatic')}
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="bodyType"
              label={t('form.vehicleForm.vehicleAdditionalDetails.bodyType')}
            >
              <Select options={translatedBodyType} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="modelYear"
              label={t('form.vehicleForm.vehicleAdditionalDetails.modelYear')}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="fuelType"
              label={t('form.vehicleForm.vehicleAdditionalDetails.fuelType')}
            >
              <Select options={translatedFuelType} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="horsePower"
              label={t('form.vehicleForm.vehicleAdditionalDetails.horsePower')}
            >
              <Input suffix={'hp'} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="vin"
              label={t('form.vehicleForm.vehicleAdditionalDetails.vin')}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="variant"
              label={t('form.vehicleForm.vehicleAdditionalDetails.variant')}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24}>
            <Form.Item
              name="description"
              label={t('form.vehicleForm.vehicleAdditionalDetails.description')}
            >
              <TextArea rows={3} allowClear />
            </Form.Item>
          </Col>
        </Row>
      </>
    </>
  );
};

export default VehicleAdditionalDetails;
